/**
 * Hands a blob to the browser as a file download.
 *
 * Lives in the web app rather than in @repo/api because it touches the DOM,
 * and that package is also compiled by apps/native.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
